/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteSearchHandlerInfo = {
    ID: KiteSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace KiteSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        ADDRESS_LABEL = 'ADDRESS_LABEL',
        TOKEN = 'TOKEN',
    }


}

